import cloneDeep from 'lodash/cloneDeep';

const sortNotificationEntries = (entries = []) => {
  const sortedEntries = cloneDeep(entries);
  sortedEntries.sort((first, second) => {
    const dateA = new Date(first.publish_date);
    const dateB = new Date(second.publish_date);
    if (dateA > dateB) {
      return -1;
    }
    if (dateA < dateB) {
      return 1;
    }
    return 0;
  });
  return sortedEntries;
};

export const getters = {
  set(st, data) {
    Object.assign(st, data);
  },
  get: (state) => (state.items),
  getForLevel: (state) => (level) => sortNotificationEntries(state.items)
    .find((entry) => entry.level === level),
};

/* eslint-disable no-param-reassign */
export const mutations = {
  setNotifications(st, items) {
    st.items = items;
  },
  setBannerVisible(st, visible) {
    st.bannerVisible = visible;
  },
  setPopupVisible(st, visible) {
    st.popupVisible = visible;
  },
};
/* eslint-enable no-param-reassign */

export const actions = {
  nuxtServerInit({ commit }, context) {
    const { req } = context;
    const { notifications } = req || {};

    commit('setNotifications', notifications || []);
  },
};

export const storeModule = {
  namespaced: true,
  state: () => ({
    items: [],
    bannerVisible: false,
    popupVisible: false,
  }),
  getters,
  mutations,
  actions,
};

export default (store) => {
  store.registerModule('notifications', storeModule);
};
